<template>
  <div>
      <div style="position:relative;overflow:hidden;padding-top:80%;">
        <embed v-if="streamKey" :src="'https://samples.quanteec.com/samples/?autoplay=true&key=' + streamKey"  style="position:absolute;top:0;left:0;width:100%;height:100%">
      </div>
  </div>
</template>

<script>
import ConfigurationService from '@/services/configuration.service.js';
let configService = new ConfigurationService();

export default {
  name: 'SamplePage',
  components: {
    
  },
  props: [
    "configKey"
  ],
  data() {
    return {
        clientView: this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
        streamKey: "",
        key: ""
    }
  },
mounted() {
  if (this.configKey) {
    this.key = this.configKey;
  } else {
     this.$route.params.key;
  }
    this.getConfigs();
  },
  methods: {
    getConfigs() {
        let self = this;
      configService.getConfigurations({filter:JSON.stringify({client: this.clientView})}, this.$auth.token()).then(configurations => {
        if (configurations._embedded && configurations._embedded.length > 0 && configurations._embedded.findIndex(a => a.key === self.key) > -1) {
            self.streamKey = self.key;
        }
      }).catch(err => {
        console.log(err);
      })
    },
  }
}
</script>